module.exports = __webpack_public_path__ + "school/img/fixd_right_bg.7951f971.png";